import { Unit } from '../components/ServiceItem';

export type Rule = {
  id: string;
  product_id?: string;
  value?: string;
  active?: boolean;
  type?: boolean | string;
  unit?: string;
  comparator?: string;
  fixed?: boolean;
  productItemId?: string;
  ruleId?: string;
  rule_id?: string;
  ruleValue?: string;
  category_id?: string;
  created_at?: string;
  updated_at?: string;
  rule?:
    | {
        id: string;
        category_id: string;
        rule: string;
        active: boolean;
        type: string;
        value: string | null;
        fixed: boolean;
        comparator: string;
        unit: string;
        created_at: string;
        updated_at: string;
      }
    | string;
};

export type CoverageProps = {
  id: string;
  item_SGH_id: string;
  item_alias: string;
  units?: Unit[];
  is_kit: boolean;
  care_type: string;
  category: string; // 'APPOINTMENT' | 'IMMUNIZATION' | 'EXAM'
  appointment_status?: 'WHATSAPP_DIRECTION' | 'AVAILABLE_AUTOAPPOINTMENT';
  rules: Rule[];
  channel?: string;
  first_appointment?: boolean;
};

export type ProductItemProps = {
  discount: string;
  discount_percent: string;
  price: string;
  id: string;
  name: string;
  recurrence_type: string;
  description: string;
  contract_type: string;
  active: boolean;
  created_at: string;
  updated_at: string;
  amount?: string;
  price_discount?: string;
  suggested_amount?: string;
  quantity?: number;
  rules?: Rule[];
  coverages?: CoverageProps[];
  idPatient?: string;
  idLocal?: string;
  is_b2b?: boolean;
  priority?: number;
  icon?: string;
};

export type ProductItemOriginal = Omit<ProductItemProps, 'idLocal' | 'quantity' | 'idPatient'>;

export function Product(product: ProductItemProps) {
  return product;
}

export function ProductOriginal(product: ProductItemOriginal) {
  const originalProduct = {} as ProductItemOriginal;
  originalProduct.discount = product.discount;
  originalProduct.discount_percent = product.discount_percent;
  originalProduct.price = product.price;
  originalProduct.id = product.id;
  originalProduct.name = product.name;
  originalProduct.recurrence_type = product.recurrence_type;
  originalProduct.description = product.description;
  originalProduct.contract_type = product.contract_type;
  originalProduct.active = product.active;
  originalProduct.created_at = product.created_at;
  originalProduct.updated_at = product.updated_at;
  originalProduct.amount = product.amount;
  originalProduct.price_discount = product.price_discount;
  originalProduct.suggested_amount = product.suggested_amount;
  originalProduct.coverages = product.coverages;
  originalProduct.is_b2b = product.is_b2b;
  originalProduct.rules = product.rules;
  originalProduct.icon = product.icon;
  return originalProduct;
}
